<template lang="html">
  <div class="vertical-table-data avoid-page-break">
    <div class="line-container">
      <div class="line" v-for="( element, index ) in data" v-bind:key="index"
      :style="[{ width : defineWidth(element.value) , transform : transformLine(element.value) }]">
        <span :class="{ positiveValue : checkIfValueIsPositive(element.value) , negativeValue : !checkIfValueIsPositive(element.value) }">
          {{ definePercentage(element.value) }}
        </span>
      </div>
    </div>
    <p class="percentage">0%</p>
    <div class="namesContainer">
      <div v-for="( element, index ) in data" v-bind:key="index" class="cards">
        <p>{{ element.name }}</p>
      </div>
    </div>
    <div class="chartContainer">
      <div class="line1"></div>
      <div class="line2"></div>
      <div class="line3"></div>
      <div class="line4"></div>
    </div>
    <div class="chartContainerTwo">
      <div class="line2"></div>
      <div class="line3"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    graph_data: Array,
    assetClassColor: String
  },
  data() {
    return {
      scalatedVersion: false,
      data: []
    };
  },
  watch: {
    graph_data: function (value) {
      this.data = value;

      let length = value.length;
      let counter = 0;
      for (let element of value) {
        let value = element.value;
        if (value < 0.5) {
          counter++;
        }
      }
      if (counter == length) {
        this.createScalatedVersion();
      }
    }
  },
  methods: {
    transformToPercentage(value) {
      let newValue = value;
      // This is multiplied for 1000 an the divided
      // between 10 to aviod bugs by multiplying for 100
      if (newValue < 0) {
        newValue = newValue * -1;
      }
      newValue = newValue * 1000;
      newValue = newValue / 10;
      if (newValue % 1 != 0) {
        newValue = newValue.toFixed(2);
      }
      return newValue;
    },
    defineWidth(value) {
      let finalValue = this.transformToPercentage(value);
      if (this.scalatedVersion) {
        finalValue = finalValue * 2;
      }
      return finalValue + "%";
    },
    definePercentage(value) {
      let finalValue = this.transformToPercentage(value);
      if (value < 0) {
        return "-" + finalValue + "%";
      }
      return finalValue + "%";
    },
    transformLine(value) {
      if (value > 0) {
        return;
      }
      return "translateX( calc(-100% - 1px) )";
    },
    checkIfValueIsPositive(value) {
      if (value >= 0) {
        return true;
      } else {
        return false;
      }
    },
    createScalatedVersion() {
      this.scalatedVersion = true;
    }
  }
};
</script>

<style lang="css" scoped>
.negativeValue {
  color: red;
  transform: translateX(-110%);
}
.positiveValue {
  right: 0px;
  transform: translateX(110%);
}
.vertical-table-data {
  display: block;
  margin: 0 auto;
  width: 552px;
  max-width: 768px;
  margin-bottom: 1em;
  padding-top: 10px;
  position: relative;
  padding-bottom: 1em;
}
.line-container {
  width: 177px;
  position: absolute;
  top: 71px;
  left: 339px;
  z-index: 1;
}
.line {
  background-color: rgb(168, 184, 221);
  height: 29px;
  margin-bottom: 20px;
  position: relative;
}
.line span {
  fill: #4a4a4a;
  font-size: 13px;
  line-height: 15px;
  font-weight: 600;
  text-anchor: start;
  position: absolute;
  top: 7px;
}
/* Names Sction */
.namesContainer {
  /* background-color: yellow; */
  float: left;
  width: 120px;
  display: inline-block;
  margin-right: 40px;
  padding-top: 24px;
}
.cards {
  height: 50px;
  /* background-color: purple; */
}
.namesContainer p {
  font-size: 14px;
  line-height: 15px;
  font-weight: 600;
  /* background-color: blue;  */
  margin: 0px;
}
/* Percentage Text */
.percentage {
  color: #848484;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  line-height: 15px;
  margin-left: 329px;
}
/* Chart */
.chart {
  /* background-color: green; */
  border-left: 1px dashed #e3ecff;
  padding-top: 24px;
  z-index: 1;
  height: 100px;
}
.chartContainer {
  width: 221px;
  height: 124px;
  display: inline-block;
  position: relative;
  border-left: 1px dashed #e3ecff;
  border-right: 1px dashed #e3ecff;
}
.chartContainerTwo {
  width: 221px;
  height: 124px;
  display: inline-block;
  position: absolute;
  margin-left: 43px;
  border-left: 1px dashed #e3ecff;
}
.line1 {
  position: absolute;
  border-right: 1px dashed #848484;
  height: 100%;
  width: 100%;
  transform: translateX(-44px);
  z-index: 0;
}
.line2 {
  position: absolute;
  border-right: 1px dashed #e3ecff;
  height: 100%;
  width: 100%;
  transform: translateX(-176px);
  z-index: 0;
}
.line3 {
  position: absolute;
  border-right: 1px dashed #e3ecff;
  height: 100%;
  width: 100%;
  transform: translateX(-132px);
  z-index: 0;
}
.line4 {
  position: absolute;
  border-right: 1px dashed #e3ecff;
  height: 100%;
  width: 100%;
  transform: translateX(-89px);
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/VerticalTableData2.vue